module.exports = __webpack_public_path__ + "static/media/15_r_rabota_89.69_37.31.651f1fcd.png";